<template>
    <div class="message" :class="(!checkisSender) ? 'sender' : 'receiver response receiver-rxn-side'">
        <template v-if="!checkisSender">
            <div class="sender-msg sender-msg-blockk">
                <div class="sender-single-msg senderr-wrapper">
                    <p>{{ messageDetail.text }} </p>
                </div>
                <template v-if="messageDetail.reactions.length > 0 ">
                    <span class="after-reactions" style="background: rgb(60, 61, 73);" 
                        @click="reactToMessage(messageDetail.id, messageDetail.reactions[0].data, messageDetail.reactions[0].data)">
                        {{ messageDetail.reactions[0].data }}
                    </span>
                </template>
            </div>
            <div class="sender-icons">
                <div class="side-   ">
                     <!-- <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                        class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" />
                    </svg>
                    <div class="side-options-list">
                       <ul>
                            <li>Message Info</li>
                            <li>Reply</li>
                            <li>React</li>
                            <li>Edit</li>
                            <li>Delete</li>
                            <li>Forward</li>
                        </ul> 
                    </div>-->
                </div>
                <div class="side-reactions">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                        class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z" />
                    </svg>
                    <div class="emoji-hover">
                        <template v-for="reaction in chatMessageReactions">
                            <span :key="reaction" @click="reactToMessage(messageDetail.id, reaction, (messageDetail.reactions.length > 0) ? messageDetail.reactions[0].data : null )">{{ reaction }}</span>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <p>{{ messageDetail.text }}</p>
            <template v-if="messageDetail.reactions.length > 0 ">
                <span class="after-reactions">{{ messageDetail.reactions[0].data }}</span>
            </template>
        </template>
    </div>
</template>

<script>
import DEFINES from "@/defines";
import { mapState } from 'vuex'
export default {
    name: "ChatMessageView",
    data() {
        return {
            chatMessageReactions:DEFINES.CHAT_MESSAGE_RECTIONS
        }
    },
    computed:{
        checkisSender() {
            // Check if In message the receiver id is the current user
            return (this.senderId === this.messageDetail.senderId) ? true : false
        }
    },
    props: {
        messageDetail: {
            type: Object,
            default:null
        },
        senderId: {
            type: Number,
            default:null
        }
    },
    methods:{
        async reactToMessage(messageId, reaction, current_reaction=null) {
            this.$emit('reactToMessage',{
                message_id:messageId,
                message_reaction: reaction,
                current_reaction
            })
        }
    }
         
}
</script>

<style lang="scss" scoped>

</style>